import { PricingsTable } from "@/features/pricings/pricings-table";

const PricingsScreen = () => {
  return (
    <div className="p-4">
      <PricingsTable />
    </div>
  );
};

export default PricingsScreen;
